// This file is generated by libs/go-core/cmd/generate-frontend-permissions.
// Do not edit directly. Update backend Go permission definitions, then regenerate.

export const ADMIN_PERMISSIONS = {
  BACKUP_CREATE: 'backup:create',
  BACKUP_READ: 'backup:read',
  BACKUP_UPDATE: 'backup:update',
  BINDINGS_CREATE: 'bindings:create',
  BINDINGS_READ: 'bindings:read',
  BINDINGS_UPDATE: 'bindings:update',
  BRANCHES_CREATE: 'branches:create',
  BRANCHES_DELETE: 'branches:delete',
  BRANCHES_READ: 'branches:read',
  BRANCHES_UPDATE: 'branches:update',
  COMPANIES_CREATE: 'companies:create',
  COMPANIES_DELETE: 'companies:delete',
  COMPANIES_READ: 'companies:read',
  COMPANIES_UPDATE: 'companies:update',
  DASHBOARD_READ: 'dashboard:read',
  PERMISSION_CREATE: 'permission:create',
  PERMISSION_DELETE: 'permission:delete',
  PERMISSION_READ: 'permission:read',
  PERMISSION_UPDATE: 'permission:update',
  REGISTRATIONS_READ: 'registrations:read',
  REGISTRATION_APPROVE: 'registrations:approve',
  REGISTRATION_REJECT: 'registrations:reject',
  ROLES_CREATE: 'roles:create',
  ROLES_DELETE: 'roles:delete',
  ROLES_READ: 'roles:read',
  ROLES_UPDATE: 'roles:update',
  SERVICE_CREATE: 'service:create',
  SERVICE_DELETE: 'service:delete',
  SERVICE_READ: 'service:read',
  SERVICE_UPDATE: 'service:update',
  SESSIONS_READ: 'sessions:read',
  USERS_CREATE: 'users:create',
  USERS_DELETE: 'users:delete',
  USERS_READ: 'users:read',
  USERS_UPDATE: 'users:update',
} as const;

export const EXPERT_PERMISSIONS = {
  API_TOKEN_CREATE: 'api-token:create',
  API_TOKEN_DELETE: 'api-token:delete',
  API_TOKEN_READ: 'api-token:read',
  API_TOKEN_UPDATE: 'api-token:update',
  ATTENDANCE_ACTIVE_SESSIONS_READ: 'attendance-active-sessions:read',
  ATTENDANCE_CREATE: 'attendance:create',
  ATTENDANCE_DAILY_SUMMARY_READ: 'attendance-daily-summary:read',
  ATTENDANCE_DELETE: 'attendance:delete',
  ATTENDANCE_EXPERTISE_ANALYTICS_READ: 'attendance-expertise-analytics:read',
  ATTENDANCE_EXPERT_DETAILED_ATTENDANCE_READ:
    'attendance-expert-detailed-attendance:read',
  ATTENDANCE_EXPERT_HISTORY_READ: 'attendance-expert-history:read',
  ATTENDANCE_EXPERT_SUMMARY_READ: 'attendance-expert-summary:read',
  ATTENDANCE_LOCATION_BASED_READ: 'attendance-location-based:read',
  ATTENDANCE_READ: 'attendance:read',
  ATTENDANCE_TIME_ANALYTICS_READ: 'attendance-time-analytics:read',
  ATTENDANCE_UPDATE: 'attendance:update',
  COMMISSION_INVOICE_APPROVE: 'commission-invoice:approve',
  COMMISSION_INVOICE_APPROVE_OWN: 'commission-invoice:approve-own',
  COMMISSION_INVOICE_CANCEL: 'commission-invoice:cancel',
  COMMISSION_INVOICE_CREATE: 'commission-invoice:create',
  COMMISSION_INVOICE_CREATE_ANY: 'commission-invoice:create-any',
  COMMISSION_INVOICE_READ: 'commission-invoice:read',
  COMMISSION_INVOICE_UPDATE: 'commission-invoice:update',
  COMMISSION_PAYMENT_CREATE: 'commission-payment:create',
  COMMISSION_PAYMENT_CREATE_ANY: 'commission-payment:create-any',
  COMMISSION_PAYMENT_READ: 'commission-payment:read',
  COMMISSION_PAYMENT_REVERSE: 'commission-payment:reverse',
  COMMISSION_READ: 'commission:read',
  COMMISSION_RULE_CREATE: 'commission-rule:create',
  COMMISSION_RULE_DELETE: 'commission-rule:delete',
  COMMISSION_RULE_READ: 'commission-rule:read',
  COMMISSION_RULE_UPDATE: 'commission-rule:update',
  COMMISSION_SETTINGS_READ: 'commission-settings:read',
  COMMISSION_SETTINGS_UPDATE: 'commission-settings:update',
  COMPANY_PERSONNEL_DELETE: 'company-personnel:delete',
  COMPANY_PERSONNEL_READ: 'company-personnel:read',
  COMPANY_PERSONNEL_UPDATE: 'company-personnel:update',
  CUSTOM_ATTRIBUTE_CREATE: 'custom-attribute:create',
  CUSTOM_ATTRIBUTE_DELETE: 'custom-attribute:delete',
  CUSTOM_ATTRIBUTE_READ: 'custom-attribute:read',
  CUSTOM_ATTRIBUTE_UPDATE: 'custom-attribute:update',
  DASHBOARD_ATTENDANCE_PRESENT_READ: 'dashboard-attendance-present:read',
  DASHBOARD_COMPANY_TOTALS_READ: 'dashboard-company-totals:read',
  DASHBOARD_EXPERTS_ACTIVE_READ: 'dashboard-experts-active:read',
  DASHBOARD_EXPERTS_TOTAL_READ: 'dashboard-experts-total:read',
  DASHBOARD_READ: 'expert-dashboard:read',
  EXPERTS_CREATE: 'experts:create',
  EXPERTS_DELETE: 'experts:delete',
  EXPERTS_READ: 'experts:read',
  EXPERTS_UPDATE: 'experts:update',
  INDUSTRY_CREATE: 'industry:create',
  INDUSTRY_DELETE: 'industry:delete',
  INDUSTRY_READ: 'industry:read',
  INDUSTRY_UPDATE: 'industry:update',
  ORGANIZATION_CREATE: 'organization:create',
  ORGANIZATION_DELETE: 'organization:delete',
  ORGANIZATION_READ: 'organization:read',
  ORGANIZATION_UPDATE: 'organization:update',
  REFERRAL_CANCEL: 'referral:cancel',
  REFERRAL_CREATE: 'referral:create',
  REFERRAL_CREATE_ON_BEHALF: 'referral-on-behalf:create',
  REFERRAL_DELETE: 'referral:delete',
  REFERRAL_READ: 'referral:read',
  REFERRAL_SOURCE_CHANNEL_CREATE: 'referral-source-channel:create',
  REFERRAL_SOURCE_CHANNEL_DELETE: 'referral-source-channel:delete',
  REFERRAL_SOURCE_CHANNEL_READ: 'referral-source-channel:read',
  REFERRAL_SOURCE_CHANNEL_UPDATE: 'referral-source-channel:update',
  REFERRAL_STAGE_CORRECT: 'referral:stage-correct',
  REFERRAL_UPDATE: 'referral:update',
  REFERRAL_VIEW_ALL: 'referral:view-all',
  REPORTS_BRANCH_COVERAGE_READ: 'reports-branch-coverage:read',
  REPORTS_EXPERTISE_WORKFORCE_MIX_READ: 'reports-expertise-workforce-mix:read',
  REPORTS_ORGANIZATION_UTILIZATION_READ:
    'reports-organization-utilization:read',
  REPORTS_READ: 'reports:read',
  WORKFLOW_READ: 'workflow:read',
  WORKFLOW_TEMPLATE_READ: 'workflow-template:read',
} as const;

export const AUDIT_PERMISSIONS = {
  AUDIT_LOGS_READ: 'audit-logs:read',
} as const;

export const TICKETING_PERMISSIONS = {
  AGENTS_CREATE: 'agents:create',
  AGENTS_DELETE: 'agents:delete',
  AGENTS_READ: 'agents:read',
  AGENTS_UPDATE: 'agents:update',
  ASSIGNMENTS_ASSIGN: 'assignments:assign',
  ASSIGNMENTS_CREATE: 'assignments:create',
  ASSIGNMENTS_DELETE: 'assignments:delete',
  ASSIGNMENTS_READ: 'assignments:read',
  ASSIGNMENTS_UPDATE: 'assignments:update',
  ATTACHMENTS_CREATE: 'attachments:create',
  ATTACHMENTS_DELETE: 'attachments:delete',
  ATTACHMENTS_READ: 'attachments:read',
  CATEGORIES_CREATE: 'categories:create',
  CATEGORIES_DELETE: 'categories:delete',
  CATEGORIES_READ: 'categories:read',
  CATEGORIES_UPDATE: 'categories:update',
  COMMENTS_CREATE: 'comments:create',
  COMMENTS_DELETE: 'comments:delete',
  COMMENTS_READ: 'comments:read',
  COMMENTS_UPDATE: 'comments:update',
  TICKETING_DASHBOARD_READ: 'ticketing-dashboard:read',
  TICKETS_CREATE: 'tickets:create',
  TICKETS_DELETE: 'tickets:delete',
  TICKETS_READ: 'tickets:read',
  TICKETS_UPDATE: 'tickets:update',
  TICKET_STATS_READ: 'ticket-stats:read',
} as const;

export const PERMISSIONS = {
  ADMIN: ADMIN_PERMISSIONS,
  EXPERT: EXPERT_PERMISSIONS,
  AUDIT: AUDIT_PERMISSIONS,
  TICKETING: TICKETING_PERMISSIONS,
} as const;

export const PERMISSION_VALUES_BY_SERVICE_KEY = {
  admin: Object.values(ADMIN_PERMISSIONS),
  expert: Object.values(EXPERT_PERMISSIONS),
  audit: Object.values(AUDIT_PERMISSIONS),
  ticketing: Object.values(TICKETING_PERMISSIONS),
} as const;

export type AdminPermission =
  (typeof ADMIN_PERMISSIONS)[keyof typeof ADMIN_PERMISSIONS];
export type ExpertPermission =
  (typeof EXPERT_PERMISSIONS)[keyof typeof EXPERT_PERMISSIONS];
export type AuditPermission =
  (typeof AUDIT_PERMISSIONS)[keyof typeof AUDIT_PERMISSIONS];
export type TicketingPermission =
  (typeof TICKETING_PERMISSIONS)[keyof typeof TICKETING_PERMISSIONS];
